<template>
    <div class="assets-transfer">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                        <div class="top-navbar-left">
                            <div class="btn-back" @click="$router.go(-1)">
                                <font-awesome-icon :icon="['fas', 'angle-left']" />
                                Back
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="top-navbar-center">Assets Transfer</div>
                    </div>
                </div>
            </div>

            <hr />
        </div>

        <div class="container mt-5">

            <div class="custom-alert alert alert-success" role="alert" v-if="isSuccess">
                Transfer created successfully.
            </div>
            <div class="custom-alert alert alert-danger" role="alert" v-if="isError">
                Please fill in the mandatory field(s).
            </div>

            <div>
                <div class="form-group">
                    <label for="">Asset Type *</label>

                    <div>
                        <div class="custom-control-inline pill-radio">
                            <input type="radio" id="tablet" name="type" value="tablet" required class="custom-control-input" v-model="selectedType">
                            <label class="" for="tablet">Tablets</label>
                        </div>
                        <div class="custom-control-inline pill-radio">
                            <input type="radio" id="uniform" name="type" value="uniform" required class="custom-control-input" v-model="selectedType">
                            <label class="" for="uniform">Uniform</label>
                        </div>
                    </div>
                </div>

                <div>

                    <h3 class="section-title mt-5">Transfer From</h3>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.fromDivision.$error }">
                                <label for="">Division *</label>

                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="from_north" name="from_division" value="0" class="custom-control-input" v-model.trim="tabletTransfer.fromDivision" @change="onChangeFromDivision">
                                        <label class="" for="from_north">East</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="from_south" name="from_division" value="1" class="custom-control-input" v-model.trim="tabletTransfer.fromDivision" @change="onChangeFromDivision">
                                        <label class="" for="from_south">West</label>
                                    </div>
                                </div>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.fromDivision.required">Division is required</div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.fromRegion.$error }">
                                <label for="">Region *</label>
                                <select class="custom-select form-control" v-model.trim="tabletTransfer.fromRegion" @change="onChangeFromRegion">
                                    <option :key="regionIndex" :value="region.id" v-for="(region, regionIndex) in filterFromRegion">{{ region.name }}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.fromRegion.required">Division is required</div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.fromArea.$error }">
                                <label for="">Area *</label>
                                <select class="custom-select form-control" v-model.trim="tabletTransfer.fromArea" @change="onChangeFromArea">
                                    <option :key="areaIndex" :value="area.id" v-for="(area, areaIndex) in filterFromArea">{{ area.name }}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.fromArea.required">Area is required</div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <h3 class="section-title mt-3">Select Asset to Transfer</h3>

                    <div class="row" >

                        <div class="col-md-12" v-if="$v.tabletTransfer.toAssets.$error">
                            <div class="form-group">
                                <div class="invalid-feedback form-error-msg" >Asset is required</div>
                            </div>
                        </div>

                        <div class="col-md-6">

                            <div class="form-group" >

                                <label for="">Available Assets <span v-if="selectedFromArea">in {{ selectedFromArea[0].name }}</span></label>


                                <div class="ba-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Product</th>
                                            <th>IMEI Number</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :key="tablet.id" v-for="tablet in tabletTransfer.fromAssets">
                                            <td>
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input" :value="tablet.id" type="checkbox" :id="'from' + tablet.id" @change="addToTransfer(tablet)">
                                                    <label class="custom-control-label" :for="'from' + tablet.id"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <label>{{ tablet.sku }}</label>
                                            </td>
                                            <td>
                                                {{ tablet.imei }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>

                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="">Selected for Transfer</label>

                                <label class="float-right">Total selected: {{ tabletTransfer.toAssets.length }}</label>


                                <div class="ba-wrapper">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th></th>
                                            <th>Product</th>
                                            <th>IMEI Number</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr :key="tablet.id" v-for="tablet in tabletTransfer.toAssets">
                                            <td>
                                                <div class="custom-control custom-checkbox">
                                                    <input class="custom-control-input" :value="tablet.id" type="checkbox" checked :id="'to' + tablet.id"  @change="removeToOrigin(tablet)">
                                                    <label class="custom-control-label" :for="'to' + tablet.id"></label>
                                                </div>
                                            </td>
                                            <td>
                                                <label>{{ tablet.sku }}</label>
                                            </td>
                                            <td>
                                                {{ tablet.imei }}
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>

                        </div>


                    </div>

                    <hr>

                    <h3 class="section-title mt-3">Transfer To</h3>

                    <!--                     <div class="row">-->
                    <!--                        <div class="col-md-3">-->
                    <!--                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.project.$error }">-->
                    <!--                                <label for="">Project</label>-->
                    <!--                                <select class="custom-select form-control" v-model.trim="tabletTransfer.project">-->
                    <!--                                    <option>121</option>-->
                    <!--                                </select>-->

                    <!--                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.project.required">Project is required</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                        <div class="col-md-3">-->
                    <!--                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.project.$error }">-->
                    <!--                                <label for="">Programme</label>-->
                    <!--                                <select class="custom-select form-control" v-model.trim="tabletTransfer.programme">-->
                    <!--                                    <option>Programme</option>-->
                    <!--                                </select>-->

                    <!--                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.project.required">Programme is required</div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.toDivision.$error }">
                                <label for="">Division *</label>
                                <div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="to_north" value="0" class="custom-control-input" v-model.trim="tabletTransfer.toDivision" @change="onChangeToDivision">
                                        <label class="" for="to_north">North</label>
                                    </div>
                                    <div class="custom-control-inline pill-radio">
                                        <input type="radio" id="to_south" value="1" class="custom-control-input" v-model.trim="tabletTransfer.toDivision" @change="onChangeToDivision">
                                        <label class="" for="to_south">South</label>
                                    </div>
                                </div>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.toDivision.required">Division is required</div>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.toRegion.$error }">
                                <label for="">Region *</label>
                                <select class="custom-select form-control" v-model.trim="tabletTransfer.toRegion" @change="onChangeToRegion">
                                    <option :key="regionIndex" :value="region.id" v-for="(region, regionIndex) in filterToRegion">{{ region.name }}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.toRegion.required">Region is required</div>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.toArea.$error }">
                                <label for="">Area *</label>
                                <select class="custom-select form-control" v-model="tabletTransfer.toArea">
                                    <option :key="areaIndex" :value="area.id" v-for="(area, areaIndex) in filterToArea">{{ area.name }}</option>
                                </select>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.toArea.required">Area is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group" :class="{ 'form-is-error': $v.tabletTransfer.photo.$error }">
                                <label for="profile_image">Photo of Transfer Form</label>
                                <input id="profile_image" type="file" @change="uploadProfileImage" hidden>

                                <label :for="tabletTransfer.photo ? '' : 'profile_image'" class="image-upload user-photo" :class="{ 'uploaded': tabletTransfer.photo }" @click="tabletTransfer.photo ? removeImage($event) : ''">
                                    <div class="btn btn-ecdc">{{ tabletTransfer.photo ? 'Remove' : 'Browse' }}</div>
                                    <img v-if="tabletTransfer.photo" :src="tabletTransfer.photo" alt="">
                                </label>

                                <div class="invalid-feedback form-error-msg" v-if="!$v.tabletTransfer.photo.required">Photo is required</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">

                        <label for="">Remarks</label>
                        <textarea name="remarks" id="remarks" rows="3" class="form-control" v-model="tabletTransfer.remarks"></textarea>
                    </div>

                </div>

                <button type="button" class="mt-3 btn btn-ecdc btn-shadow" @click="checkForm">Submit</button>
            </div>

        </div>

        <app-loader v-show="isLoading"></app-loader>
    </div>
</template>

<script>
    import Loader from './Loader.vue'
    import {getAreas, getRegions, getTabletsToTransferByArea, storeTabletTransfer} from "../api";
    import { required } from 'vuelidate/lib/validators'

    export default {
        components: {
            appLoader: Loader,
            // appIconSearch: IconSearch,
        },
        data() {
            return {
                selectedType: 'tablet',
                regions: [],
                areas: [],
                selectedFromArea: '',
                isLoading: true,
                isError: false,
                isSuccess: false,
                toggleFilter: true,
                tabletTransfer: {
                    project: '121',
                    programme: 'Programme',
                    fromDivision: '',
                    fromRegion: '',
                    fromArea: '',
                    toDivision: '',
                    toRegion: '',
                    toArea: '',
                    photo: '',
                    remarks: '',
                    fromAssets: [],
                    toAssets: [],

                },
                rawUniformSizes: '',
                rawShoeSizes: '',
            }
        },
        validations: {
            tabletTransfer: {
                project: {
                    required
                },
                programme: {
                    required
                },
                fromDivision: {
                    required
                },
                fromRegion: {
                    required
                },
                fromArea : {
                    required
                },
                toDivision: {
                    required
                },
                toRegion: {
                    required
                },
                toArea: {
                    required
                },
                photo: {
                    required
                },
                toAssets: {
                    required
                }
            },
        },
        async mounted() {

            await this.getRegions();
            await this.getAreas();
            this.isLoading = false;
        },
        computed: {
            filterFromRegion: function() {
                return this.regions.filter((item) => {
                    if(this.tabletTransfer.fromDivision === '') {
                        return item;
                    } else {
                        return item.division == this.tabletTransfer.fromDivision
                    }
                });
            },
            filterFromArea: function() {
                return this.areas.filter((item) => {
                    if(this.tabletTransfer.fromRegion === '') {
                        return item;
                    } else {
                        return item.region_id == this.tabletTransfer.fromRegion
                    }
                });
            },
            filterToRegion: function() {
                return this.regions.filter((item) => {
                    if(this.tabletTransfer.toDivision === '') {
                        return item;
                    } else {
                        return item.division == this.tabletTransfer.toDivision
                    }
                });
            },
            filterToArea: function() {
                return this.areas.filter((item) => {
                    if(this.tabletTransfer.toRegion === '') {
                        return item;
                    } else {
                        return item.region_id == this.tabletTransfer.toRegion
                    }
                });
            }
        },
        methods: {
            async getTablets() {
                let result = await getTabletsToTransferByArea({area: this.tabletTransfer.fromArea});
                this.tabletTransfer.fromAssets = result.data.tablets;
            },
            addToTransfer(data) {
                this.tabletTransfer.toAssets.push(data);

                let id = this.tabletTransfer.fromAssets.map(value => value.id).indexOf(data.id);
                this.tabletTransfer.fromAssets.splice(id, 1);
            },
            removeToOrigin(data) {
                this.tabletTransfer.fromAssets.push(data);

                let id = this.tabletTransfer.toAssets.map(value => value.id).indexOf(data.id);
                this.tabletTransfer.toAssets.splice(id, 1);
            },
            checkForm() {
                const _this = this;

                this.$v.tabletTransfer.$touch();

                if(this.$v.tabletTransfer.$invalid) {

                    this.isError = true;
                    window.scrollTo(0, 0);

                    setTimeout(function() {

                        _this.isError = false;
                    }, 2000);
                } else {
                    this.createTransfer();
                }
            },
            async createTransfer() {
                let _this = this;
                this.isLoading = true;

                try {
                    await storeTabletTransfer(this.tabletTransfer);
                    this.isSuccess = true;

                    window.scrollTo(0, 0);

                    setTimeout(function() {

                        _this.isSuccess = false;
                        _this.$router.push({ name: "assetsTabletsDetails" });
                    }, 2000);
                } catch (err) {
                    alert(err.response.data.message);
                }
                this.isLoading = false;
            },
            uploadProfileImage(e) {

                let file = e.target.files ;

                if (!file.length)
                    return;

                let isValid = this.validationFile(file[0]);

                if(isValid) {
                    this.createImage(file[0]);
                }
            },
            createImage(file) {
                let reader = new FileReader();
                let _this = this;

                reader.readAsDataURL(file);

                reader.onload = (e) => {
                    _this.tabletTransfer.photo = e.target.result;
                };

                reader.onerror = (err) => {
                    alert(err);
                };

                document.getElementById('profile_image').value = "";
            },
            removeImage(e) {
                e.preventDefault();

                if(this.tabletTransfer.photo) {
                    this.tabletTransfer.photo = '';
                }

            },
            validationFile(file) {

                if(!file.type.startsWith("image")) {

                    alert("Please upload image format file.");
                }
                else if(file.size > 3145728) {

                    alert("Please upload less than 3mb image.");
                }
                else {

                    return true;
                }

                return false;
            },
            async getRegions() {

                try {
                    const result = await getRegions();
                    this.regions = result.data.data;
                }
                catch(err) {
                    alert(err.response.data.message);
                }
            },
            async getAreas() {

                try {
                    const result = await getAreas();
                    this.areas = result.data.data;
                }
                catch(err) {
                    alert(err.response.data.message);
                }
            },
            onChangeFromDivision() {
                this.tabletTransfer.fromRegion = '';
                this.tabletTransfer.fromArea = '';
                this.selectedFromArea = '';
            },
            onChangeFromRegion() {
                this.tabletTransfer.fromArea = '';
                this.selectedFromArea = '';
            },
            onChangeFromArea() {
                this.tabletTransfer.toAssets = [];

                if(this.tabletTransfer.fromDivision && this.tabletTransfer.fromRegion && this.tabletTransfer.fromArea) {
                    this.getTablets();
                }

                this.selectedFromArea = this.areas.filter(item => {

                    return item.id === this.tabletTransfer.fromArea
                })
            },
            onChangeToDivision() {
                this.tabletTransfer.toRegion = '';
                this.tabletTransfer.toArea = '';
            },
            onChangeToRegion() {
                this.tabletTransfer.toArea = '';
            },
        }
    }
</script>